/* eslint-disable no-param-reassign */

import { adobeTrack } from 'src/lib/adobe_track';
import { rolexConsentGranted } from 'src/lib/rolex_cookies';

const adobeTrackAnalytics = () => {
  if (window.location.pathname.match(/^\/rolex/)) {
    if (rolexConsentGranted()) {
      adobeTrack('Analytics');
    }
  }

  // turn off turbo drive for all rolex pages
  // add data-turbo: false to all a tags that point
  // to a /rolex* path
  document.querySelectorAll('a').forEach((aTag) => {
    if (aTag.href !== '') {
      const url = new URL(aTag.href);
      if (url.pathname.match(/^\/rolex/)) {
        aTag.dataset.turbo = 'false';
      }
    }
  });
};

const rolexPageView = () => {
  // 2023-08-03: We used to send "Analyticsconsent","false/true"
  // based on the value of the rlx-consent cookie. the new update
  // says we should not do that

  document.removeEventListener('turbo:load', adobeTrackAnalytics);
  document.addEventListener('turbo:load', adobeTrackAnalytics);
};

export default rolexPageView;
